import { AdvizedTest, AdvizedToplist, ExpertGuide } from '../../../types';

type Item = AdvizedTest | AdvizedToplist | ExpertGuide | any | null;

/**
 * Compare function for sorting Adviced content in arrays
 */
export const compareByDate = (a: Item, b: Item) => {
  // If null or undefined, move to bottom of list
  if (!a || !a.publishedAt) return 1;
  if (!b || !b.publishedAt) return -1;
  return parseInt(b.publishedAt, 10) - parseInt(a.publishedAt, 10);
};
